import { render, staticRenderFns } from "./AwardEmptyLink.vue?vue&type=template&id=ad9670a2&scoped=true&"
import script from "./AwardEmptyLink.vue?vue&type=script&lang=js&"
export * from "./AwardEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9670a2",
  null
  
)

export default component.exports